import React, { useEffect } from "react";
import { useState } from "react";
import { connect, useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { icon, label, number, tooltip } from "../../../config";
import { splitString } from "../../../utils";
import { getCurrentActiveProject } from "../sidebar.common";
import { getBreadCrumbList } from "../sidebar.helper";
import DetailedProjectTrails from "./DetailedProjectTrails";
import HeaderActions from "./HeaderActions";

/**
 * HeaderTitle component handles project trails logic
 * @props {}
 */
const HeaderTitle = ({ defaultDetails, activeUserList, currentFlowSetter, breadcrumbs, setBreadcrumbs, currentFlow, flowElementsSectionRef }) => {
  const [showPopup, setShowPopup] = React.useState(false);
  const [showLastWedges, setShowLastWedges] = React.useState(false);
  const projectTrailsRef = React.useRef(null);
  const { isNewTask, task, flowElements, activeMemberVariables } = useSelector((state) => state.taskSidebar);
  const { user } = useSelector((state) => state.auth);
  const [openFlow, setOpenFlow] = React.useState(null);
  const [openTrail, setOpenTrail] = useState(false);
  const wedgesRef = React.useRef(null);

  /**
   * used to set these values setIsSelected, currentFlowSetter, setCurrentActiveView, setBreadcrumbs on first render
   * @author {Himanshu Negi}
   */

  useEffect(() => {
    if (!isNewTask) {
      const { currentProject: currentActiveProject, currentProjectIndex: isCurrent } = getCurrentActiveProject(flowElements);
      const breadcrumbsList = getBreadCrumbList(flowElements, currentActiveProject, isCurrent, activeMemberVariables);
      const activeFlowIndex = breadcrumbsList?.findLastIndex((item) => item.id === currentActiveProject?.id);
      currentFlowSetter(breadcrumbsList[activeFlowIndex]);
      setBreadcrumbs(breadcrumbsList);
      setShowLastWedges(
        flowElements.length > number.THREE && flowElements[flowElements.length - number.ONE] !== breadcrumbsList[breadcrumbsList.length - number.ONE]
      );
    }
  }, [flowElements, isNewTask, activeMemberVariables]);

  /**
   * gives key value pairs of project codes and their respective task delegators
   * @returns {Object}
   */

  /**
   * handlea ProjectTrails Popup
   */
  const handleProjectTrailsPopup = (flowId) => {
    if (!flowId) setOpenTrail(true);
    setShowPopup(!showPopup);
    setOpenFlow(flowId);
  };

  const CustomTooltip = (props) => {
    const name = splitString(props.title, "-|")[number.ZERO];
    const email = splitString(props.title, "-|")[number.ONE];
    return (
      <>
        {splitString(props.title, "-|").length == number.TWO && (
          <div>
            <div>{name}</div>
            <div> {email}</div>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <Tooltip className='pre-line' anchorElement='target' position='bottom' parentTitle='true'>
        {!isNewTask && (
          <div className='header-projecttrais'>
            {task && task.ProjectCode && (
              <div>
                <ul className='wizard d-flex text-center justify-content-center' ref={projectTrailsRef}>
                  {breadcrumbs &&
                    breadcrumbs?.map((flow, index) => {
                      let projectCode = "";
                      let ProjectName = "";
                      if (flow.flowElementType === number.TWO) {
                        projectCode = label.DYNAMIC;
                        ProjectName = flow.name;
                      } else {
                        let currentProject = defaultDetails?.allProjectsList?.find((project) => project?.ProjectId == flow?.assignmentProjectId);
                        projectCode = currentProject?.ProjectCode;
                        ProjectName = currentProject?.ProjectName;
                      }
                      const hasActiveEscalation = parseInt(flow?.isTaskEscalate) || parseInt(flow?.isNotificationEscalate);
                      return (
                        <React.Fragment key={index}>
                          {
                            <li
                              id={`task-sidebar-breadcrumb-${flow?.id}`}
                              className={`wizard-item h-100 position-static d-inline-flex justify-content-center align-items-center cursor-pointer ${
                                currentFlow?.id == flow?.id ? "wizard-active-item" : ""
                              }`}
                              onClick={() => handleProjectTrailsPopup(flow?.id)}>
                              {showPopup && (openFlow == flow?.id || openTrail) && (
                                <DetailedProjectTrails anchor={projectTrailsRef} setShowPopup={openTrail ? setOpenTrail : setShowPopup} flowElementsSectionRef={flowElementsSectionRef} />
                              )}
                              {!!flow.isApproval && (
                                <span className='verified-icon position-absolute' title={tooltip.APPROVAL}>
                                  {icon.APPROVAL_ICON}
                                </span>
                              )}
                              {hasActiveEscalation ? (
                                <span 
                                  className={`escalation-icon position-absolute escalation-icon-active`}
                                  title={label.TASK_ESCALATED}>
                                  {icon.TASK_ESCALATION}
                                </span>
                              ): <></>}
                              <span className='wizard-inner d-flex flex-column'>
                                <span className='wizard-title font-weight-semi-bold overflow-hidden' title={`${ProjectName}`}>
                                  {projectCode}
                                </span>
                              </span>
                            </li>
                          }
                        </React.Fragment>
                      );
                    })}
                  {showLastWedges && (
                    <div className='cursor-pointer' onClick={() => handleProjectTrailsPopup()}>
                      {" "}
                      {Array(number.THREE)
                        .fill()
                        .map((_, index) => (
                          <li
                            key={index}
                            className='wizard-item h-100 position-static d-inline-flex justify-content-center align-items-center last-wizard cursor-pointer'></li>
                        ))}
                    </div>
                  )}
                </ul>
              </div>
            )}
          </div>
        )}
      </Tooltip>
      {!isNewTask && (
        <Tooltip anchorElement='target' position='bottom' parentTitle='true' content={(props) => CustomTooltip(props)}>
          <div className='active-user-list d-flex align-items-center justify-content-center'>
            {activeUserList?.map((usr, index) => (
              <React.Fragment key={index}>
                {usr.value != user.id && (
                  <span className='active-user-list-item border-radius-50 cursor-pointer' title={usr?.label + "-|" + usr?.Email}>
                    {usr.PhotoLinks?.small ? (
                      <img alt={usr.label} src={usr.PhotoLinks?.small} className='border-radius-50 object-fit-cover'></img>
                    ) : (
                      icon.ACCOUNT_CIRCLE
                    )}
                  </span>
                )}
              </React.Fragment>
            ))}
          </div>
        </Tooltip>
      )}
      <HeaderActions />
    </>
  );
};
/**
 * merges ReduxStore with props
 * @param {*} state
 * @returns {state as props}
 */
function mapStateToProps(state) {
  return {
    auth: state.auth,
    defaultDetails: state.tasks.defaultDetails,
    allTasks: state.tasks.allTasks,
  };
}
export default connect(mapStateToProps, null)(HeaderTitle);
